<template>
  <v-row no-gutters class="flex-0-0" align="center">
    <v-row no-gutters class="flex-0-0 d-none d-md-flex" style="gap: 20px">
      <NuxtLink
        class="nav-menu-item"
        active-class="active-nav-item"
        :to="ABOUT_US_ROUTE"
      >
        <v-btn-text>{{ $t("taHome.aboutUs") }}</v-btn-text>
      </NuxtLink>
      <NuxtLink
        class="nav-menu-item"
        active-class="active-nav-item"
        :to="SERVICES_ROUTE"
      >
        <v-btn-text>{{ $t("taHome.services") }}</v-btn-text>
      </NuxtLink>
      <NuxtLink
        class="nav-menu-item"
        active-class="active-nav-item"
        :to="CASE_STUDIES_ROUTE"
      >
        <v-btn-text>{{ $t("taHome.caseStudies") }}</v-btn-text>
      </NuxtLink>
      <v-btn-text>{{ $t("taHome.blog") }}</v-btn-text>
      <NuxtLink
        class="nav-menu-item"
        active-class="active-nav-item"
        :to="CONTACT_US_ROUTE"
      >
        <v-btn-text class="d-none d-lg-inline-block">{{
          $t("taHome.contactUs")
        }}</v-btn-text>
      </NuxtLink>
    </v-row>
    <v-row
      class="flex-0-0 px-5 px-md-0 pl-lg-5 pr-md-0 d-none d-sm-flex"
      no-gutters
    >
      <NuxtLink :to="`${CONTACT_US_ROUTE}#freeconsultation`">
        <v-btn
          size="large"
          class="px-4 px-sm-6 text-button"
          color="secondary"
          variant="elevated"
          >{{ $t("taHome.getFreeConsultation") }}</v-btn
        >
      </NuxtLink>
    </v-row>
    <v-menu
      transition="slide-y-transition"
      close-on-back
      location="start"
      class="full-screen-width-menu d-block d-md-none"
    >
      <template v-slot:activator="{ props, isActive }">
        <v-icon
          class="d-inline d-md-none"
          v-bind="props"
          :icon="isActive ? 'mdi-close' : 'mdi-menu'"
          :color="isActive ? 'error' : 'primary'"
          size="40"
        ></v-icon>
      </template>
      <v-list
        style="
          margin-top: 52px;
          border-radius: 0px;
          border-top: 0.5px solid rgb(var(--v-theme-light-grey));
          box-shadow: -2px -5px 0px 0px white,
            2px 1px 3px 0px rgb(var(--v-theme-dark-grey)) !important;
        "
        :bg-color="menuColor"
        :class="{ 'morph-sm-color': isGlassMorph }"
        class="custom-scroll-container"
      >
        <v-container
          class="d-flex align-center flex-column mt-2 mt-sm-0 position-relative"
          style="gap: 10px"
        >
          <!-- <v-icon
            size="30"
            style="position: absolute; cursor: pointer; right: 10px; top: 10px"
            icon="mdi-close"
            color="error"
          ></v-icon> -->
          <v-defaults-provider
            :defaults="{
              VBtnText: {
                style: 'font-size: 17px',
              },
            }"
          >
            <NuxtLink
              class="nav-menu-item"
              active-class="active-nav-item"
              :to="ABOUT_US_ROUTE"
            >
              <v-btn-text>{{ $t("taHome.aboutUs") }}</v-btn-text>
            </NuxtLink>
            <NuxtLink
              class="nav-menu-item"
              active-class="active-nav-item"
              :to="SERVICES_ROUTE"
            >
              <v-btn-text>{{ $t("taHome.services") }}</v-btn-text>
            </NuxtLink>
            <NuxtLink
              class="nav-menu-item"
              active-class="active-nav-item"
              :to="CASE_STUDIES_ROUTE"
            >
              <v-btn-text>{{ $t("taHome.caseStudies") }}</v-btn-text>
            </NuxtLink>
            <v-btn-text>{{ $t("taHome.blog") }}</v-btn-text>
            <NuxtLink
              class="nav-menu-item"
              active-class="active-nav-item"
              :to="CONTACT_US_ROUTE"
            >
              <v-btn-text>{{ $t("taHome.contactUs") }}</v-btn-text>
            </NuxtLink>
          </v-defaults-provider>
          <v-row
            class="d-flex d-sm-none"
            justify="center"
            no-gutters
            style="gap: 10px"
          >
            <NuxtLink :to="`${CONTACT_US_ROUTE}#freeconsultation`">
              <v-btn
                size="large"
                class="px-4 px-sm-6 text-button"
                color="secondary"
                variant="elevated"
                >{{ $t("taHome.getFreeConsultation") }}</v-btn
              >
            </NuxtLink>
          </v-row>
        </v-container>
      </v-list>
    </v-menu>
  </v-row>
</template>
<script setup lang="ts">
import {
  CASE_STUDIES_ROUTE,
  CONTACT_US_ROUTE,
  ABOUT_US_ROUTE,
  SERVICES_ROUTE,
} from "~/core/routes/app_routes";
const isHomePage: boolean = useRoute().fullPath === "/";
defineProps<{ menuColor?: string; isGlassMorph?: boolean }>();
</script>
<style scoped>
.nav-menu-item {
  position: relative;
  padding: 0px !important;
  color: rgb(var(--v-theme-primary)) !important;
}
.nav-menu-item::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 2px;
  background: rgb(var(--v-theme-secondary));
  bottom: 3px;
  transform: scaleX(0);
  left: 0;
  transform-origin: center;
  transition: 0.3s transform ease-in;
}
.nav-menu-item:hover::before {
  transform: scaleX(1);
}
@media screen and (max-width: 959px) {
  .morph-sm-color {
    background-color: rgb(var(--v-theme-background)) !important;
  }
}

.active-nav-item::before {
  transform: scaleX(1);
}
</style>
